// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2IX_v","validationTips":"StatementDescriptor_validationTips__2WqcO"};